import { Site, SLD, type HeaderService, type ListItem } from '@patsnap-utils/biz';
import { getCurrentLanguage } from '@eureka/language-tool';
import '@patsnap-ui/icon/assets/solid/HistoryRecord.svg';
import '@patsnap-ui/icon/assets/userpackage.svg';
import '@patsnap-ui/icon/assets/solid/rocket.svg';
import '@patsnap-ui/icon/assets/solid/AI.svg';
import '@patsnap-ui/icon/assets/solid/Gift.svg';
import { combineHash, combineUrl } from '@eureka/utils/url';
import { clientDeferred } from '@eureka/utils/client';
import { useLsEditionUsage, usePlg } from '@eureka/shared/edition-upgrade';

type ILocale = 'cn' | 'en' | 'tw' | 'jp'
export interface CustomLinksOptions {
    checkAgentSettingsPermission?: () => Promise<boolean>;
}

export async function customProductsLinkInUserCenter(headerService: HeaderService, options?: CustomLinksOptions) {
    const locale = getCurrentLanguage() as ILocale;
    const buildin = headerService.userCenterService.beforeRenderMenuItems
    const { isFeiShu } = await clientDeferred.promise

    const { isPersonal } = useLsEditionUsage();
    const { checkIsLsPlg } = usePlg();
    const isLsPlg = await checkIsLsPlg();

    // 异步检查agent-settings权限
    let hasAgentSettingsPermission = false;
    if (options?.checkAgentSettingsPermission) {
        options.checkAgentSettingsPermission().then(permission => {
            hasAgentSettingsPermission = permission;
        }).catch(() => {
            hasAgentSettingsPermission = false;
        });
    }

    headerService.userCenterService.beforeRenderMenuItems = function beforeRenderMenuItems(items: ListItem[]) {
        let _items = buildin(items);
        _items.splice(1, 0, {
            href: new Site({ sld: SLD.EUREKA, pathname: 'history' }).href,
            label: ({
                cn: '历史记录',
                en: 'History',
                jp: '履歴',
                tw: '歷史記錄',
            })[locale],
            icon: 'SolidHistoryRecord',
            key: 'history',
        })

        // 只在有权限时添加个性化设置菜单
        if (hasAgentSettingsPermission && !isFeiShu) {
            _items.splice(2, 0, {
                href: combineHash(combineUrl(location.origin, 'ls'), 'user-setting/agent-settings'),
                label: ({
                    cn: '个性化设置',
                    en: 'customization',
                    jp: 'エージェント設定',
                    tw: '個性化設置',
                })[locale],
                icon: 'SolidAi',
                key: 'agent-settings',
            })
        }

        if (!isFeiShu) {
            const versionUrl = isLsPlg ? new Site({ sld: SLD.EUREKA, pathname: 'user-setting/package/management' }).href : combineHash(combineUrl(location.origin, 'ls'), 'user-setting/package/ls');

            _items.splice(0, 0, {
                href: versionUrl,
                label: ({
                    cn: '所有版本',
                    en: 'All versions',
                    jp: 'すべてのバージョンになります',
                    tw: '所有版本',
                })[locale],
                icon: 'SolidRocket',
                key: 'version',
            })
        }

        _items.splice(0, 0, {
            href: combineHash(combineUrl(location.origin, 'ls'), 'user-setting/amount'),
            label: ({
                cn: '用量',
                en: 'Usage',
                jp: '利用回数',
                tw: '用量',
            })[locale],
            icon: 'Userpackage',
            key: 'package',
        })

        if (isFeiShu) {
            _items.splice(-2, 2)
        }

        if (isPersonal.value) {
            const nonePackages = ['package', 'settings', 'team']
            _items = _items.filter(item => !nonePackages.includes(item.key as string));
        }
        return _items;
    }
}
